"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XAxis_1 = require("./XAxis");
exports.XAxis = XAxis_1.default;
var xAxisOptions_1 = require("./xAxisOptions");
exports.xAxisOptions = xAxisOptions_1.default;
//# sourceMappingURL=index.js.map